import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";
import apiPath from "../constants/apiPath";
import axios from "axios";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({ token: null });
  const [userProfile, setUserProfile] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) return;
    const userRaw = localStorage.getItem("user");
    if (userRaw) {
      const user = JSON.parse(userRaw);
      setUserProfile(user);
    }
    setIsLoggedIn(true);
    setSession({ token: token });
  }, []);

  useEffect(() => {
    if (!userProfile) return;
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return;
  };

  const logout = async () => {
    try {
      const refresh = localStorage.getItem("refreshToken");
      const sessionId = localStorage.getItem("session_id");
      const token = localStorage.getItem("token");
      setLoading(true);
      const response = await axios.post(`${apiPath.baseURL}/auth/logout`,
        {
          refresh: refresh,
          session_id: sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setLoading(false);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("session_id");
        ShowToast("Logout Successfully", Severty.SUCCESS);
        window.location.assign("/login");
      }
    } catch (error) {
      console.log("Error occured while logout admin", error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
